export const moduleRwd = {
	state() {
		return {
			windowWidth: 0,
			showMobileMenu: false,
			mobileBreakpoing: 1024,
		};
	},
	mutations: {
		setWindowWidth(state, data) {
			state.windowWidth = data;
		},
		setShowMobileMenu(state, data) {
			state.showMobileMenu = data;
		},
	},
	getters: {
		getWindowWidth: (state) => state.windowWidth,
		getShowMobileMenu: (state) => state.showMobileMenu,
		getMobileBreakpoing: (state) => state.mobileBreakpoing,
	},

	actions: {
		toggleMobileMenu({ commit }, show) {
			commit('setShowMobileMenu', show);
			let bodyClass = document.body.className;
			if (!bodyClass.includes('mobile-menu-open') && show)
				document.body.className = bodyClass + 'mobile-menu-open';
			else document.body.className = '';
		},

		windowResize({ commit }) {
			commit('setWindowWidth', window.innerWidth);
		},
	},
};
